import type { SortDir } from '@/lib/sortTable';

/**
 * Clickable sortable column header cell. Shows an ▲/▼ indicator on the active
 * column. Drop into a table's <thead> row in place of a plain <th>.
 */
export function SortHeader({
  label, columnKey, sortKey, sortDir, onSort, className,
}: {
  label: string;
  columnKey: string;
  sortKey: string;
  sortDir: SortDir;
  onSort: (k: string) => void;
  className?: string;
}) {
  const active = sortKey === columnKey;
  return (
    <th className={`px-3 py-2 ${className ?? ''}`}>
      <button
        type="button"
        onClick={() => onSort(columnKey)}
        aria-label={`Sort by ${label}`}
        className="inline-flex items-center gap-1 font-semibold uppercase tracking-wide text-darkGrey/70 hover:text-navy"
      >
        {label}
        {active
          ? <span className="text-[10px] leading-none text-orange">{sortDir === 'asc' ? '▲' : '▼'}</span>
          : <span className="text-[10px] leading-none text-darkGrey/30" aria-hidden>↕</span>}
      </button>
    </th>
  );
}
